import Route from 'cio/routes/base';
import WarehouseSyncModel from 'cio/models/warehouse-sync';

export default class IntegrationsWarehouseSync extends Route {
  redirect(): void {
    let model = this.modelFor('integrations.warehouse');

    if (model && model instanceof WarehouseSyncModel) {
      this.router.transitionTo('integrations.warehouse.type', { queryParams: { type: model.type } });
    }
  }
}
